import React from 'react'
import {MenuItem, Menu, ListItem} from '@material-ui/core'
import {FormatUnderlined, FormatBold, FormatItalic} from '@material-ui/icons'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import useStyles from './TTextStyle.styles'

const TTextStyle = props => {
  const classes = useStyles(props.value || {})
  const {font_weight, text_decoration, font_style} = props.value
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleToggleFontWeight = e => {
    props.onChange('font_weight', font_weight === 'bold' ? '' : 'bold')
    setAnchorEl(null)
  }
  const handleToggleFontStyle = e => {
    props.onChange('font_style', font_style === 'italic' ? '' : 'italic')
    setAnchorEl(null)
  }
  const handleToggleTextDecoration = e => {
    props.onChange('text_decoration', text_decoration === 'underline' ? '' : 'underline')
    setAnchorEl(null)
  }

  return (
    <>
      <ListItem
        component="a"
        aria-controls="simple-menu"
        aria-haspopup="true"
        className={classes.root}
        onClick={handleClick}
      >
        <FormatBold />
        <ArrowDropDownIcon />
      </ListItem>
      <Menu
        defaultValue={props.value}
        value={props.value}
        onChange={props.onChange}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
      >
        <MenuItem className={classes.optionActiveFontWeight} onClick={handleToggleFontWeight}>
          <FormatBold className={classes.option} />
        </MenuItem>
        <MenuItem className={classes.optionActiveFontStyle} onClick={handleToggleFontStyle}>
          <FormatItalic className={classes.option} />
        </MenuItem>
        <MenuItem className={classes.optionActiveTextDeco} onClick={handleToggleTextDecoration}>
          <FormatUnderlined className={classes.option} />
        </MenuItem>
      </Menu>
    </>
  )
}

export default TTextStyle
